import React from "react";
import { Tab, Nav, Dropdown } from "react-bootstrap";
import MediumImage from "../ProfileImages/MediumImages/MediumImage";
import "./Dropdown.scss";

function HomeDropdown(props) {
  const onSelect = (e) => {
    props.onSelect(e);
  };
  const handleClick = (title, type, item) => {
    props.onClick(title, type, item);
  };

  return (
    <Dropdown onSelect={(e) => onSelect(e)}>
      <Dropdown.Toggle className={props.className}>
        {props.src ? <MediumImage src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/user.svg`} /> : props.drop}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props &&
          props.Dropdownitem &&
          props.Dropdownitem.map((dropdown) => (
            <Dropdown.Item
              eventKey={dropdown.eventKey}
              // key={dropdown.key}
              onClick={() =>
                dropdown.key != "Doc"
                  ? handleClick(
                      dropdown.sort,
                      dropdown.key,
                      dropdown.onClickItem
                    )
                  : ""
              }
            >
              {dropdown && dropdown.img && (
                <img
                  src={dropdown.img}
                  alt="img"
                  className={`${props.itemClassName} mr-2`}
                />
              )}
              <span className={dropdown.key == "Doc" ? "disable_btn" : ""}>
                {dropdown.name}
              </span>
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default HomeDropdown;
